module.exports = __webpack_public_path__ + "img/logo.b70b9d36.png";